<template>
  <span class="tag" :style="style">{{name}}</span>
</template>

<script>
export default {
  components: {},
  props: {
    name: { type: String, required: true },
    color: { type: String, required: false }, // 文字颜色
    bgcolor: { type: String, required: false }, // 背景颜色
    bdcolor: { type: String, required: false }, // 边框颜色
  },
  data() {
    const style_list = [
      {
        name: "岗位外包",
        color: "#05b8fe",
        backgroundColor: "#effafe",
        border: "1px solid #05b8fe"
      },
      {
        name: "员工派遣",
        color: "#f26828",
        backgroundColor: "#fff7f5",
        border: "1px solid #f26828"
      },
      {
        name: "劳务外包",
        color: "#5c74f5",
        backgroundColor: "#eff2fe",
        border: "1px solid #5c74f5"
      },
      {
        name: "社保代理",
        color: "#ffb646",
        backgroundColor: "#fff8f0",
        border: "1px solid #ffb646"
      },
      {
        name: "薪酬代发",
        color: "#fe527b",
        backgroundColor: "#fef2f5",
        border: "1px solid #fe527b"
      }
    ];
    let style = style_list.find(e => e.name === this.name) || {};
    if (this.color != undefined) {
      style.color = this.color;
    }
    if (this.bgcolor != undefined) {
      style.backgroundColor = this.bgcolor;
    }
    if (this.bdcolor != undefined) {
      style.border = "1px solid" + this.bdcolor;
    }
    
    return {
      style
    };
  }
};
</script>
<style lang="scss" scoped>
.tag {
  display: flex;
  align-items: center;
  padding: 0px 10px;
  height: 24px;
  line-height: 14px;
  font-size: 14px;
  border-radius: 8px;
}
</style>